import React from "react";

import { ProgressBarConfig, WidgetDeviceType } from "@intelligems/ig-types";
import { ProgressBarView } from "@intelligems/ig-widgets";
import { useProgressBarCurrencyFormatter } from "@src/domains/WidgetLibrary/ProgressBar/useProgressBarCurrencyFormatter";
import { useProgressBarContext } from "@src/features/personalizations/components/offerModifications/userInterfaces/progressBar/ProgressBarContext";

export interface IgProgressBarProps {
  config: ProgressBarConfig;
  device: WidgetDeviceType;
}

export const IgProgressBar = ({ config, device }: IgProgressBarProps) => {
  const formatter = useProgressBarCurrencyFormatter();
  const { cartValue } = useProgressBarContext();

  return (
    <ProgressBarView
      renderType={device}
      config={config}
      cartValue={cartValue}
      formatter={formatter}
    />
  );
};
